import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

function Menu({
  options,
  onClick,
  selected
}) {
  return (
    <nav
      className="Menu"
    >
      {
        options.map((item, i) => (
          <div
            className={classnames(
              'Menu-link', `Menu-link--${item}`, {
                'Menu-link--selected': selected === item
              }
            )}
            key={i}
            onClick={() => onClick(item)}
          >
            {item}
          </div>
        ))
      }
    </nav>
  );
}

Menu.propTypes = {
  selected: PropTypes.string,
  options: PropTypes.array,
  onClick: PropTypes.func
};

Menu.defaultProps = {
  selected: false,
  options: [],
  onClick: () => false
};

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu.js